<template>
    <div style="display: flex;align-items: center;justify-content: center;">
      <SelUpWay :hidden="supway" @s_person="s_person" @s_cus="s_cus"></SelUpWay>
      <UpPerson :hidden="v_upperson" @showsh="showsh"></UpPerson>
      <UpCus :hidden="v_upcus" @showsh="showsh"></UpCus>
      <ShowSH :hidden="vshowsh"></ShowSH>
      <ShowCusInfo :hidden="vshowcusinfo"></ShowCusInfo>
      <ShowPeron :hidden="vshowperson"></ShowPeron>
    </div>
</template>

<script>
  import SelUpWay from './SelUpWay'
  import UpPerson from './UpPerson'
  import UpCus from './UpCus'
  import ShowSH from './ShowSH'
  import ShowCusInfo from './ShowCusInfo'
  import ShowPeron from './ShowPeron'
  var that
  export default {
    name: 'CompleteInfo',
    components: {
      ShowPeron,
      ShowCusInfo,
      UpPerson,
      SelUpWay,
      ShowSH,
      UpCus
    },
    data () {
      return {
        supway: false,
        v_upperson: true,
        v_upcus: true,
        vshowsh: true,
        vshowcusinfo: true,
        vshowperson: true
      }
    },
    mounted () {
      that = this
      document.title = '账号升级'
      if (parseInt(localStorage.getItem('usergroupid')) === 8){
        if (parseInt(localStorage.getItem('userstate')) === 0 || localStorage.getItem('userstate') === null) {
          that.vshowsh = false
          that.supway = true
          that.v_upperson = true
          that.v_upcus = true
          that.vshowcusinfo = true
          that.vshowperson = true
        } else {
          that.vshowsh = true
          that.supway = true
          that.v_upperson = true
          that.v_upcus = true
          that.vshowperson = false
          that.vshowcusinfo = true
        }
      } else if (parseInt(localStorage.getItem('usergroupid')) === 9) {
        if (parseInt(localStorage.getItem('userstate')) === 0 || localStorage.getItem('userstate') === null) {
          that.vshowsh = false
          that.supway = true
          that.v_upperson = true
          that.v_upcus = true
          that.vshowperson = true
          that.vshowcusinfo = true
        } else {
          that.vshowsh = true
          that.supway = true
          that.v_upperson = true
          that.v_upcus = true
          that.vshowperson = true
          that.vshowcusinfo = false
        }
      }
    },
    methods:{
      s_person () {
        that.v_upperson = false
        that.supway = true
        that.v_upcus = true
      },
      s_cus () {
        that.v_upperson = true
        that.supway = true
        that.v_upcus = false
      },
      showsh (state) {
        if (state === 0) {
          that.vshowsh = false
          that.supway = true
          that.v_upperson = true
          that.v_upcus = true
          that.vshowcusinfo = true
        } else {
          that.vshowcusinfo = false
          that.supway = true
          that.v_upperson = true
          that.v_upcus = true
          that.vshowsh = true
        }
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/regedit/CompleteInfo.vue